import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { BlogsPage } from './pages/BlogsPage';
import { BlogPost } from './pages/BlogPost';
export function App() {
  return <Router data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/blog" element={<BlogsPage data-id="element-6" />} data-id="element-5" />
          <Route path="/blog/:id" element={<BlogPost data-id="element-8" />} data-id="element-7" />
        </Routes>
      </Layout>
    </Router>;
}